import { CheckIcon } from '@primer/octicons-react';
import React, { Suspense } from 'react';
import { graphql, useFragment } from 'react-relay';

import { ProblemGeneratorDeactivateDialog_problemGenerator$key } from '../../../relay/__generated__/ProblemGeneratorDeactivateDialog_problemGenerator.graphql';
import { ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation } from '../../../relay/__generated__/ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation.graphql';
import Button from '../../core/Button';
import Dialog, { DialogProps } from '../../core/Dialog';
import MutationFormik, { MutationFormikProps } from '../../core/MutationFormik';
import NonFieldError from '../../core/NonFieldError';
import Text from '../../core/Text';
import UserAvatarRadioGroupField from '../../user/UserAvatarRadioGroupField';

const ProblemGeneratorDeactivateDialog_problemGenerator = graphql`
  fragment ProblemGeneratorDeactivateDialog_problemGenerator on ProblemGenerator {
    id
  }
`;

type Props = { problemGenerator: ProblemGeneratorDeactivateDialog_problemGenerator$key } & DialogProps &
  Pick<
    MutationFormikProps<ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation>,
    'onSubmit' | 'config' | 'connections'
  >;

const ProblemGeneratorDeactivateDialog = ({
  isOpen,
  onSubmit,
  config,
  connections,
  problemGenerator,
  ...props
}: Props) => {
  const { id } = useFragment(ProblemGeneratorDeactivateDialog_problemGenerator, problemGenerator);
  return (
    <Dialog isOpen={isOpen} {...props}>
      <Dialog.Header>
        <Text sx={{ fontSize: 3, fontWeight: 'bold' }}>검수 요청하기</Text>
      </Dialog.Header>
      <MutationFormik<ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation>
        mutation={graphql`
          mutation ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation(
            $input: ProblemGeneratorDeactivateInput!
          ) {
            problemGeneratorDeactivate(input: $input) {
              id
              actions
              ...ProblemGeneratorStatusLabel_problemGenerator
              ...ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator
              assigned
              assignedTo {
                id
                ...UserAvatarText_user
              }
            }
          }
        `}
        initialValues={{
          id,
          assignedTo: '',
        }}
        onSubmit={onSubmit}
        config={config}
        connections={connections}
      >
        {({ handleSubmit }) => (
          <>
            <Dialog.Body>
              <NonFieldError sx={{ marginBottom: 3 }} />
              <Suspense>
                <UserAvatarRadioGroupField
                  label={'검수자'}
                  name={'assignedTo'}
                  required
                  variables={{ filters: { team_In: ['contents'] } }}
                />
              </Suspense>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant={'primary'} leadingIcon={CheckIcon} size={'large'} onClick={() => handleSubmit()}>
                요청하기
              </Button>
            </Dialog.Footer>
          </>
        )}
      </MutationFormik>
    </Dialog>
  );
};

export default ProblemGeneratorDeactivateDialog;
